import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import Header from '../Vulnerability/Header';
import ResolvedReason from '../ResolvedReason';
import Description from '../Vulnerability/Description';
import Remediation from '../Vulnerability/Remediation';
import Dependency from '../Vulnerability/Dependency';
import Details from '../Vulnerability/Details';
import NVDBaseMetrics from '../Vulnerability/NVDBaseMetrics';
import References from '../Vulnerability/References';
import Footer from '../Vulnerability/Footer';
import IssueGenericContent from './IssueGenericContent';
import type { IssueDetailsTab } from '../Tabs';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import VulnerabilityIssueLoading from './Loading/VulnerabilityIssueLoading';
import CPEBanner from '../Vulnerability/CPEBanner';

type VulnerabilityIssueDrawerContentProps = {
  activeTab: IssueDetailsTab;
  setActiveTab: (tab: IssueDetailsTab) => void;
};

const VulnerabilityIssueContent: VoidFunctionComponent<VulnerabilityIssueDrawerContentProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const isLoadingIssueDetails = useSelector(IssuesV2Store.selectors.getIsLoadingIssueDetails);

  if (isLoadingIssueDetails) {
    return <VulnerabilityIssueLoading />;
  }

  return (
    <IssueGenericContent
      headerSlot={<Header />}
      contentSlot={
        <>
          <CPEBanner />
          <ResolvedReason />
          <Remediation />
          <Details />
          <Dependency />
          <Description />
          <NVDBaseMetrics />
          <References />
          <Footer />
        </>
      }
      setActiveTab={setActiveTab}
      activeTab={activeTab}
    />
  );
};

export default VulnerabilityIssueContent;
